var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#003EA8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 23.5C18.85 23.9 19.3667 24.0958 20 24.0875C20.6333 24.0792 21.1 23.85 21.4 23.4L27 15L18.6 20.6C18.15 20.9 17.9125 21.3583 17.8875 21.975C17.8625 22.5917 18.05 23.1 18.45 23.5ZM20 12C20.9833 12 21.9292 12.1375 22.8375 12.4125C23.7458 12.6875 24.6 13.1 25.4 13.65L23.5 14.85C22.95 14.5667 22.3792 14.3542 21.7875 14.2125C21.1958 14.0708 20.6 14 20 14C17.7833 14 15.8958 14.7792 14.3375 16.3375C12.7792 17.8958 12 19.7833 12 22C12 22.7 12.0958 23.3917 12.2875 24.075C12.4792 24.7583 12.75 25.4 13.1 26H26.9C27.2833 25.3667 27.5625 24.7083 27.7375 24.025C27.9125 23.3417 28 22.6333 28 21.9C28 21.3 27.9292 20.7167 27.7875 20.15C27.6458 19.5833 27.4333 19.0333 27.15 18.5L28.35 16.6C28.85 17.3833 29.2458 18.2167 29.5375 19.1C29.8292 19.9833 29.9833 20.9 30 21.85C30.0167 22.8 29.9083 23.7083 29.675 24.575C29.4417 25.4417 29.1 26.2667 28.65 27.05C28.4667 27.35 28.2167 27.5833 27.9 27.75C27.5833 27.9167 27.25 28 26.9 28H13.1C12.75 28 12.4167 27.9167 12.1 27.75C11.7833 27.5833 11.5333 27.35 11.35 27.05C10.9167 26.3 10.5833 25.5042 10.35 24.6625C10.1167 23.8208 10 22.9333 10 22C10 20.6167 10.2625 19.3208 10.7875 18.1125C11.3125 16.9042 12.0292 15.8458 12.9375 14.9375C13.8458 14.0292 14.9083 13.3125 16.125 12.7875C17.3417 12.2625 18.6333 12 20 12Z",
    fill: "#003EA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLimit);
export default __webpack_public_path__ + "static/media/ic-limit.51c9bfd0d747870258bcaf213f7f4380.svg";
export { ForwardRef as ReactComponent };